<template>
  <div v-if="composition" class="publishing-properties">
    <div v-if="composition.sellables.length > 0" class="preview">
      <p>
        {{ $t('PUBLISHING.DETAIL.PRODUCTS.PRODUCTS_CREATED.HEADING') }}:
        {{ composition.sellables.length }}
      </p>
      <SellableGrid class="sellables" :composition="composition" :max="6" />
      <button
        class="link-main icon-btn icon-right edit-btn"
        @click="emit('openProductSettings')"
      >
        {{ $t('GENERAL.VIEW_ALL') }}
        <Icon icon="right" />
      </button>
    </div>
    <div v-else class="empty">
      <p>{{ $t('PUBLISHING.DETAIL.PRODUCTS.PRODUCTS_CREATED.EMPTY') }}</p>
      <button class="btn btn-primary" @click="emit('openProductSettings')">
        {{ $t('PUBLISHING.DETAIL.PRODUCTS.PRODUCTS_CREATED.ADD_NEW') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { AdvancedComposition } from '@spreadgroup/common-partner-lib/composition';
import { useCompositionStore } from 'commons/stores/composition';
import SellableGrid from 'src/app/components/publishing/SellableGrid.vue';

const emit = defineEmits<{
  openProductSettings: [];
}>();

const compositionStore = useCompositionStore();

const composition = computed(
  () => compositionStore.current as AdvancedComposition,
);
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/constants';

.publishing-properties {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 100%;

  p {
    margin: 0;
    font-weight: 700;
  }
}

.preview {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  .sellables {
    width: 100%;
  }
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  flex: 1;
}
</style>
